/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Input as ChakraInput,
  InputProps as ChakraInputProps,
  FormControl,
  FormErrorMessage,
  FormLabel,
  InputGroup,
} from '@chakra-ui/react';
import React, { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import InputMask from 'react-input-mask';

interface IInputDocumentProps extends Omit<ChakraInputProps, 'size'> {
  name: string;
  label?: string;
}

//Tipagem com erro devido a versão do react-input-mask
const InputMaskAny = InputMask as any;

export const InputDocument: React.FC<IInputDocumentProps> = ({
  name,
  label,
  ...rest
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const mask = useMemo(() => {
    if (rest.type === 'cnpj') {
      return '99.999.999/9999-99';
    }
    return '999.999.999-99';
  }, [rest.type]);

  return (
    <FormControl isInvalid={!!errors[name]}>
      {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
      <InputGroup>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <InputMaskAny mask={mask} maskChar={null} {...field}>
              {(inputProps: any) => (
                <ChakraInput id={name} {...inputProps} {...rest} bg="white" />
              )}
            </InputMaskAny>
          )}
        />
      </InputGroup>
      <FormErrorMessage>
        {errors?.[name] && (errors[name]?.message as string)}
      </FormErrorMessage>
    </FormControl>
  );
};
